var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "experience" },
    [
      _c("h3", { staticClass: "mb-8" }, [_vm._v("Suivi d'accompagnement :")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.canUpdate()
            ? _c(
                "vs-button",
                {
                  staticStyle: { "margin-bottom": "2em" },
                  attrs: {
                    id: "addSuivi",
                    color: "primary",
                    type: "filled",
                    "icon-pack": "feather",
                    icon: "icon-plus",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createResource()
                    },
                  },
                },
                [_vm._v("\n            Ajouter un nouveau Suivi\n        ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "DialogPrompt",
        {
          attrs: {
            active: _vm.showPopup,
            title: _vm.getDataPrompt.title,
            "cancel-text": "Annuler",
            "accept-text": "Enregistrer",
            "button-accept": _vm.getDataPrompt.btnAccept,
            "is-valid": !_vm.hasError,
          },
          on: {
            "update:active": function ($event) {
              _vm.showPopup = $event
            },
            cancel: _vm.resetResource,
            close: _vm.resetResource,
            accept: _vm.storeResource,
          },
        },
        [
          _c("div", { staticClass: "con-exemple-prompt" }, [
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Type* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c(
                    "multiselect",
                    {
                      attrs: {
                        name: "suiviTypes",
                        options: _vm.trainingTypes,
                        multiple: false,
                        "group-select": false,
                        placeholder: "Recherche ...",
                        "track-by": "id",
                        label: "name",
                        "select-label": "",
                        "selected-label": "",
                        "deselect-label": "",
                        loading: _vm.trainingTypesLoading,
                      },
                      model: {
                        value: _vm.resource.experience_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "experience_type", $$v)
                        },
                        expression: "resource.experience_type",
                      },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "noResult" }, slot: "noResult" },
                        [_vm._v("Aucun résultat.")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Libellé* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { name: "suiviName" },
                    model: {
                      value: _vm.resource.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "name", $$v)
                      },
                      expression: "resource.name",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Date* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { type: "date", name: "suiviEndDate" },
                    model: {
                      value: _vm.resource.start_date,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "start_date", $$v)
                      },
                      expression: "resource.start_date",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Auteur :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { name: "suiviAuthor" },
                    model: {
                      value: _vm.resource.author,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "author", $$v)
                      },
                      expression: "resource.author",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Commentaire :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-textarea", {
                    staticClass: "w-full",
                    attrs: { name: "suiviComment" },
                    model: {
                      value: _vm.resource.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "comment", $$v)
                      },
                      expression: "resource.comment",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c(
                "div",
                { staticClass: "vx-col sm:w-1/3 w-full" },
                [
                  _c(
                    "span",
                    { staticStyle: { float: "left", "line-height": "26px" } },
                    [
                      _vm._v(
                        "\n                        Pièce jointe  \n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.documentLicence
                    ? _c("vs-chip", { attrs: { color: "secondary" } }, [
                        _c("b", [
                          _vm._v(
                            "Gratuit jusqu'à " +
                              _vm._s(_vm.postMaxSizePerPerson) +
                              " Mo"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _vm.resource.doc_path
                    ? [
                        _vm._l(
                          _vm.resource.doc_path.split(";"),
                          function (doc_path, index) {
                            return [
                              _c(
                                "div",
                                { staticClass: "vx-row mb-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "inline mr-1 float-left cursor-pointer",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.download(doc_path)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(doc_path.split("/").pop())
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("vs-button", {
                                    staticStyle: {
                                      display: "inline",
                                      "margin-top": "-0.5rem",
                                    },
                                    attrs: {
                                      id: "deleteDoc_Sui_" + doc_path,
                                      color: "primary",
                                      type: "border",
                                      size: "small",
                                      "icon-pack": "feather",
                                      icon: "icon-trash",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeDocPath(
                                          _vm.resource,
                                          doc_path
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          }
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vx-col sm:w-2/3 w-full" },
                    [
                      _c("vs-input", {
                        staticClass: "w-full",
                        attrs: {
                          type: "file",
                          multiple: "",
                          accept: _vm.acceptExtensions("all"),
                          name: "doc_path",
                          danger: this.fileError.message,
                          "danger-text": this.fileError.message,
                        },
                        on: { change: _vm.selectFile },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "DialogPrompt",
        {
          attrs: {
            active: _vm.showPopupFullStorage,
            title: "Votre espace de stockage est plein",
            "cancel-text": "Annuler",
            "accept-text": "OK",
          },
          on: {
            "update:active": function ($event) {
              _vm.showPopupFullStorage = $event
            },
            close: function ($event) {
              _vm.showPopupFullStorage = false
            },
            accept: function ($event) {
              _vm.showPopupFullStorage = false
            },
          },
        },
        [
          _c("div", { staticClass: "con-exemple-prompt" }, [
            _c("p", [_vm._v(_vm._s(_vm.popupFullStorageMessage))]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "vs-table",
        {
          staticClass: "whitespace-pre-line",
          staticStyle: { width: "100%" },
          attrs: {
            sst: true,
            data: _vm.items.data,
            "no-data-text": "Aucune donnée à afficher",
          },
          on: { sort: _vm.eventSortByCol },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ data }) {
                return _vm._l(data, function (item, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr, attrs: { data: item } },
                    [
                      _c("vs-td", { attrs: { data: item.type } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.experience_type.name) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-td", { attrs: { data: item.name } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.name) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-td", { attrs: { data: item.start_date } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("date")(item.start_date)) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-td", { attrs: { data: item.author } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.author) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-td", {
                        attrs: { data: item.comment },
                        domProps: { innerHTML: _vm._s(item.comment) },
                      }),
                      _vm._v(" "),
                      item.doc_path
                        ? _c(
                            "vs-td",
                            [
                              _vm._l(
                                item.doc_path.split(";"),
                                function (doc_path, index) {
                                  return [
                                    doc_path
                                      ? _c("i", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: {
                                                content: doc_path
                                                  .split("/")
                                                  .pop(),
                                                placement: "top-start",
                                                classes: ["occ-description"],
                                              },
                                              expression:
                                                "{\n                                content: doc_path.split('/').pop(),\n                                placement: 'top-start',\n                                classes: ['occ-description']\n                            }",
                                            },
                                          ],
                                          key: "file_" + doc_path + index,
                                          class:
                                            "ml-1 fa fa-file" +
                                            (doc_path.split(".").pop() === "pdf"
                                              ? "-pdf"
                                              : ""),
                                          staticStyle: {
                                            "font-size": "2rem",
                                            color: "rgba(var(--vs-primary),1)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.download(doc_path)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        : _c("vs-td"),
                      _vm._v(" "),
                      _vm.canUpdate()
                        ? _c(
                            "vs-td",
                            [
                              _vm.can("update", "employees")
                                ? _c("vs-button", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Modifier",
                                        expression: "'Modifier'",
                                      },
                                    ],
                                    attrs: {
                                      id: "modifyRAE_" + indextr,
                                      color: "primary",
                                      type: "border",
                                      "icon-pack": "feather",
                                      icon: "icon-edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.updateResource(item)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.can("update", "employees")
                                ? _c("vs-button", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Supprimer",
                                        expression: "'Supprimer'",
                                      },
                                    ],
                                    staticStyle: { "margin-left": "1rem" },
                                    attrs: {
                                      id: "deleteRAE_" + indextr,
                                      color: "primary",
                                      type: "border",
                                      "icon-pack": "feather",
                                      icon: "icon-trash",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteResource(item)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "experience_type.name" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Type")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "name" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Libellé")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "start_date" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Date")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "vs-th",
                [
                  _c(
                    "Sort",
                    {
                      attrs: { name: "author" },
                      on: { sort: _vm.eventSortByCol },
                    },
                    [_vm._v("Auteur")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("vs-th", [
                _vm._v("\n                Commentaire\n            "),
              ]),
              _vm._v(" "),
              _c("vs-th", [_vm._v("\n                Document\n            ")]),
              _vm._v(" "),
              _vm.canUpdate()
                ? _c("vs-th", [
                    _vm._v("\n                Actions\n            "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }